import setting from '../setting'
import warningRestaurants from '../warning_restaurants'
import alertRestaurants from '../alert_restaurants'
import pendingRegulatoryRestaurants from '../pending_regulatory_restaurants'
import restaurantManage from '../restaurant_manage'
import terminal from '../terminal'
import oilRecord from '../oil_record'
import breakdownTerm from '../breakdown_term'
import addRestaurant from '../add_restaurant'
import addTerminal from '../add_terminal'

export default [{
  path: '/home',
  component: () => import('./Home.vue'),
  meta: {
    title: '首页'
  },
  children: [
    {
      path: '/',
      name: 'home',
      component: () => import('../global_statistics/GlobalStatis.vue'),
      meta: {
        title: '全局统计'
      }
    },
    ...warningRestaurants,
    ...alertRestaurants,
    ...pendingRegulatoryRestaurants,
    ...restaurantManage,
    ...terminal,
    ...oilRecord,
    ...breakdownTerm,
    ...setting,
    ...addRestaurant,
    ...addTerminal
  ]
}]



// WEBPACK FOOTER //
// ./src/router/home/index.js